import React, { useState } from 'react'
import styled from 'styled-components';
// import { AiOutlineCloudServer } from "react-icons/ai";

const Header = () => {
    const [bar, setBar] = useState(false);
    return (
        <Container bar={bar}>
            <Logo>
                {/* <span className='green'><AiOutlineCloudServer /></span> */}
                <img 
                src="https://technicianstorage.blob.core.windows.net/wearshop/Projects/logo-no-background.svg"
                alt="logo"
                />
                {/* <h1>Portfolio</h1> */}
            </Logo>
            <Nav bar={bar}>
                <span><a onClick={() => setBar(!bar)} href="#home">Home</a></span>
                <span><a onClick={() => setBar(!bar)} href="#service">Services</a></span>
                <span><a onClick={() => setBar(!bar)} href="#project">Work</a></span>
                {/* <span><a onClick={() => setBar(!bar)} href="#client">Testimonials</a></span> */}
                <span><a onClick={() => setBar(!bar)} href="#certification">Certifications</a></span>
                <span><a onClick={() => setBar(!bar)} href="#blog">Blogs</a></span>
                {/* <span><a onClick={() => setBar(!bar)} target="_blank" rel="noopener noreferrer" href="https://muhammadimran-dev.medium.com">Blogs</a></span> */}
                <span><a onClick={() => setBar(!bar)} href="#contact">Contact</a></span>
            </Nav>
            <div
                onClick={() => setBar(!bar)}
                className="bars">
                <div className="bar"></div>
            </div>
        </Container>
    )
}

export default Header

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1280px;
    width: 80%;
    margin: 0 auto;
    padding: 1rem 0;
    position: relative;
    animation: header 500ms ease-in-out;
    @media(max-width: 840px){
        width: 90%;
    }
    .bars{
        display: none;
    }
    @media(max-width:640px){
        .bars{
            width: 40px;
            height: 40px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.5rem;
            z-index: 100;
            .bar{
                position: absolute;
                width: 100%;
                height: 2px;
                background-color: ${props => props.bar ? "transparent" : "#fff"};
                transition: all 400ms ease-in-out;
                :before, :after{
                    content: "";
                    width: 100%;
                    height: 2px;
                    background-color: #fff;
                    position: absolute;
                }

                :before{
                    transform: ${props => props.bar ? "rotate(45deg)" : "translateY(10px)"};
                    transition: all 400ms ease-in-out;
                }

                :after{
                    transform: ${props => props.bar ? "rotate(-45deg)" : "translateY(-10px)"};
                    transition: all 400ms ease-in-out;
                }
            }
        }
    }
`
const Logo = styled.div`
    display: flex;
    align-items: center;
    span{
        font-size: 1.8rem;
    }
    img{
        width:3rem;
        height:3rem;
        transition: transform 400ms ease-in-out;
        :hover {
            transform: rotate(360deg);
        }
    }

    h1{
        font-weight: 600;
        font-size: 1.2rem;
    }
`
const Nav = styled.div`
    @media(max-width:640px){
        position: fixed;
        display: flex;
        flex-direction: column;
        background-color: #01be96;
        inset: 0;
        justify-content: center;
        align-items: center;
        font-size: 2rem;
        gap: 2rem;
        font-weight: 700;
        height: ${props => props.bar ? "100vh" : 0};
        transition: height 400ms ease-in-out;
        overflow: hidden;
        z-index: 100;
    }
    span{
        margin-left: 1rem;
        a{
            color: #fff;
            text-decoration: none;
            font-weight: 400;
            position: relative;
            :before{
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: -5px;
                height: 2px;
                background-color: #fff;
                transform: scale(0);
                transform-origin: right;
                transition: transform 400ms ease-in-out;
            }
            :hover:before{
                transform: scale(1);
                transform-origin: left;
            }
            :hover{
                opacity: 0.7;
            }
        }
    }
`